import {analytics} from '../globals/config';

/**
 * Dealer data reference, set externally to avoid circular dependency.
 * @type {object|null}
 */
let _garageLocatorDataRef = null;

/**
 * Set the garageLocatorData reference for dealer info enrichment.
 * Called once from garageLocator module during init.
 */
export function setApGarageLocatorDataRef(ref) {
    _garageLocatorDataRef = ref;
}

export default function (step, option = null) {
    const eventData = steps[step];
    const impressionData = impressionSteps[step];

    if (option) {
        eventData.info.toolStepOption = option;
    }

    // Enrich with dealer information when available
    if (_garageLocatorDataRef && _garageLocatorDataRef.garageID) {
        eventData.info.dealerID = _garageLocatorDataRef.garageID;
        eventData.info.dealerName = _garageLocatorDataRef.name || '';
    }

    if (eventData) {
        if (impressionData) {
            handleImpressions(step);
        }

        analytics.trackEvent(eventData);
    } else {
        console.error(`No event data found for step: ${step}`);
    }
}

const steps = {
    // Choose Dealer
    'choose-dealer--start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'dealer',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 1,
        },
    },
    'choose-dealer--submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'dealer',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 1,
            dealerID: '',
            dealerName: '',
        },
    },

    // Choose Date
    'choose-date--start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'date-picker',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 1.1,
        },
    },
    'choose-date--submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'date-picker',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 1.1,
        },
    },

    // Vehicle
    'vehicle-info--start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'vehicle-info',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 2,
        },
    },
    'vehicle-info--submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'vehicle-info',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 2,
        },
    },

    // Choose Services
    'choose-service--start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'services',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 3,
        },
    },
    'choose-service--submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'services',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 3,
        },
    },

    // Choose Replacement
    'choose-replacement--start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'mobility-solution',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 4,
        },
    },
    'choose-replacement--submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'mobility-solution',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 4,
        },
    },

    // Personal info
    'personal-info--start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'personal-info',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 5,
        },
    },
    'personal-info--submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'personal-info',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 5,
        },
    },

    // Validation
    'validation--start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'validation',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 6,
        },
    },
    'validation--submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'validation',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 6,
            dealerID: '',
            dealerName: '',
        },
    },

    // Confirmation
    'confirmation--start': {
        event: 'tool-complete',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-appointment',
            toolStep: 'thank-you',
            leadID: '',
            requestType: 'appointment',
            toolStepOption: '',
            toolStepNumber: 7,
            dealerID: '',
            dealerName: '',
        },
    },
}

const impressionSteps = {
    'choose-dealer--start': {
        subSectionOne: 'dealer',
        pageName: 'wonderservice/appointment/dealer',
    },
    'choose-date--start': {
        subSectionOne: 'date-picker',
        pageName: 'wonderservice/appointment/date-picker',
    },
    'vehicle-info--start': {
        subSectionOne: 'vehicle-info',
        pageName: 'wonderservice/appointment/vehicle-info',
    },
    'choose-service--start': {
        subSectionOne: 'services',
        pageName: 'wonderservice/appointment/services',
    },
    'choose-replacement--start': {
        subSectionOne: 'mobility-solution',
        pageName: 'wonderservice/appointment/mobility-solution',
    },
    'personal-info--start': {
        subSectionOne: 'personal-info',
        pageName: 'wonderservice/appointment/personal-info',
    },
    'validation--start': {
        subSectionOne: 'validation',
        pageName: 'wonderservice/appointment/validation',
    },
    'confirmation--start': {
        subSectionOne: 'thank-you',
        pageName: 'wonderservice/appointment/thank-you',
    },
};

export function handleImpressions(step) {
    let analytics = analyticstracker();
    let previousTrackingObject = JSON.parse(sessionStorage.getItem('trackingObject'));
    let currentTrackingObject = JSON.parse(document.querySelector('body').dataset.trackingInfo);
    let initialReferrer = sessionStorage.getItem('initialReferrer');

    if (!initialReferrer && document.referrer.indexOf(window.location.hostname) === -1) {
        sessionStorage.setItem('initialReferrer', document.referrer);
        initialReferrer = document.referrer;
        currentTrackingObject.initialReferrer = initialReferrer;
    }

    if (previousTrackingObject) {
        let previousPageObject = String(previousTrackingObject.pageUrl).split('?')[0];
        let previousPage = String(document.referrer).split('?')[0];
        let currentPage = String(window.location.href).split('?')[0];

        if (currentPage !== previousPage && previousPage === previousPageObject) {
            currentTrackingObject.previousPageFullUrl = previousTrackingObject.pageFullUrl;
            currentTrackingObject.previousPageName = previousTrackingObject.pageName;
            currentTrackingObject.previousPageType = previousTrackingObject.pageType;
            currentTrackingObject.previousPageUrl = previousTrackingObject.pageUrl;
            currentTrackingObject.previousPlatform = previousTrackingObject.platform;
            currentTrackingObject.previousBrand = previousTrackingObject.brand;
            currentTrackingObject.previousDealerID = previousTrackingObject.dealerID;
            currentTrackingObject.previousPageViewMode = previousTrackingObject.pageviewMode;
            currentTrackingObject.initialReferrer = initialReferrer;
        }

        if (impressionSteps[step]) {
            let subSectionOne = impressionSteps[step].subSectionOne;
            let subSectionTwo = impressionSteps[step].subSectionTwo;
            let pageName = impressionSteps[step].pageName;

            if (subSectionOne) {
                currentTrackingObject.subSectionOne = subSectionOne;
            }

            if (subSectionTwo) {
                currentTrackingObject.subSectionTwo = subSectionTwo;
            }

            if (pageName) {
                currentTrackingObject.pageName = pageName;
            }

            currentTrackingObject.pageType = 'form';
            currentTrackingObject.section = 'appointment';
        }

        document.querySelector('body').dataset.trackingInfo = JSON.stringify(currentTrackingObject);
        sessionStorage.setItem('trackingObject', document.querySelector('body').dataset.trackingInfo);
    } else {
        document.querySelector('body').dataset.trackingInfo = JSON.stringify(currentTrackingObject);
        sessionStorage.setItem('trackingObject', document.querySelector('body').dataset.trackingInfo);
    }

    analytics.trackImpression('page-impression');
}
